import TextField from "@/components/layouts/History/TextField";
import { sourcesFromIdx } from "@/pages/leads/helpers";
import { useLeadTypes } from "@/pages/leads/hooks";
import { useTranslation } from "react-i18next";

interface Props {
  value: string;
}

const SourceName: React.FC<Props> = ({ value }) => {
  const { t } = useTranslation();

  const sources = useLeadTypes().data?.leadsTypes ?? [];
  const source = sourcesFromIdx(t, sources, Number(value));
  return <TextField>{source}</TextField>;
};

export default SourceName;
